const MODULE_NAME = 'monthReducer';

const monthSelector = {
    monthSelectList: (state) => state[MODULE_NAME].monthSelectList,
    currentMonth: (state) => state[MODULE_NAME].currentMonth,
};

export default monthSelector;
